module.exports = __webpack_public_path__ + "img/1.ea2776e7.jpg";